module.exports = __webpack_public_path__ + "img/zhxj.fdf8fa20.png";